import {
  OnboardingContext,
  OnboardingModuleAdditionalInformation,
  OnboardingStep,
  OnboardingStepStatus
} from "../types";
import { AdditionalInformation } from "../steps/AdditionalInformation";
import { getVerificationMissingData } from "../../../services/api/onboarding/missingFields";
import { EDD_FIELDS } from "../components/EDDQuestionnaire/utils";
import { FeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { getVerifications } from "../../../services/api/onboarding/verifications";

export const getAdditionalInformationStepConfig = (
  _: OnboardingModuleAdditionalInformation,
  __: OnboardingContext,
  featureFlags: FeatureFlags | undefined,
  missingData:
    | Awaited<ReturnType<typeof getVerificationMissingData>>
    | undefined,
  verifications: Awaited<ReturnType<typeof getVerifications>> | undefined
): OnboardingStep | null => {
  const isMissingDataExist = EDD_FIELDS.some(field => {
    return missingData?.requiredFields?.includes(field.name);
  });

  if (!featureFlags?.onboardingEDDquestionnaire) {
    return null;
  }

  const slug = "additional-information";

  const isLoading = !missingData || !verifications;
  const isSuccess =
    verifications?.enhanced === "Verified" && !isMissingDataExist;
  const isPending =
    verifications?.enhanced === "Pending" && !isMissingDataExist;

  const status: OnboardingStepStatus = isLoading
    ? "Loading"
    : isSuccess
    ? "Complete"
    : isPending
    ? "Pending"
    : "None";

  return {
    title: "Additional information",
    slug,
    component: AdditionalInformation,

    status,
    result: {
      Pending: {
        title: "Additional information pending review",
        type: "search",
        description:
          "Thank you for providing the necessary information. Check back on your homepage for updates.\n\nThe review period typically takes about one to two (1-2) business days, during this time you may not be able to send/receive payments or access banking features."
      },
      Complete: {
        title: "Additional information complete",
        description: "Thank you for providing the necessary information."
      }
    }
  };
};
